Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValueConditionally = exports.getFunctionAsCallbackOrUndefined = exports.executeFunctionOrUndefined = void 0;

var executeFunctionOrUndefined = function executeFunctionOrUndefined(func) {
  if (typeof func === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return func.apply(void 0, args);
  }

  return undefined;
};

exports.executeFunctionOrUndefined = executeFunctionOrUndefined;

var getFunctionAsCallbackOrUndefined = function getFunctionAsCallbackOrUndefined(func) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  if (typeof func === 'function') {
    return function () {
      return func.apply(void 0, args);
    };
  }

  return undefined;
};

exports.getFunctionAsCallbackOrUndefined = getFunctionAsCallbackOrUndefined;

var getValueConditionally = function getValueConditionally(condition, value, defaultValue) {
  return condition ? value : defaultValue;
};

exports.getValueConditionally = getValueConditionally;